import { store, getContext, getElement } from "@wordpress/interactivity";

interface AnimatedHeightContext {
	innerHeight: number | string;
}

export function setup(storeNamespace) {
	store(storeNamespace, {
		state: {
			get wrapperHeightStyle() {
				const { innerHeight } = getContext<AnimatedHeightContext>();

				if (null === innerHeight || "auto" === innerHeight) {
					return "auto";
				}

				return `${innerHeight}px`;
			},
		},
		callbacks: {
			initAnimatedHeightResizeObserver: () => {
				const { ref } = getElement();
				const context = getContext<AnimatedHeightContext>();
				const resizeObserver = new ResizeObserver((entries, observer) => {
					if (context.innerHeight !== entries[0].target.clientHeight) {
						context.innerHeight = entries[0].target.clientHeight;
					}
				});
				if (ref) {
					resizeObserver.observe(ref);
				}
			},
		}
	});
}
